import React, { Component } from 'react';
import TagManagerUtils from '../../../utils/TagManagerUtils';
import './Tooltip.css';

class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = ({
      view: false,
    });
  }

  heandle = () => {
    const { view } = this.state;
    const {tag} = this.props;
    if (tag && !view) {
      TagManagerUtils.globalTag(tag)
    }
    this.setState({ view: !view });
    
  }

  render() {
    const { message } = this.props;
    const { view } = this.state;
    return (
      <>
        <span className="tooltip">
          <button type="button" onClick={() => this.heandle()}>?</button>
          {view && (<span className="tooltiptext">{message}</span>)}
        </span>
      </>
    );
  };
};

export default Tooltip;